import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Typography,
  Box,
  CardContent,
  Toolbar,
  IconButton,
  Badge,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Tooltip,
  ListItemButton,
  ListItemText,
  List,
  ListSubheader,
  Card,
  CardHeader,
  ListItem,
  CardActions,
  ListItemAvatar,
  Avatar,
  Autocomplete,
} from "@mui/material";

import { connect } from "react-redux";
import NoRecordMessage from "../../../common/components/NoRecordMessage";

import {
  getTraineeSubCategories,
  saveTraineeSubCategory,
} from "../../../../../store/cpd/actions";

import ConfirmationDialog from "../../../common/components/ConfirmationDialog";
import ReactPaginate from "react-paginate";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useRequiredAuth } from "../../../common/guard/requiredAuth";
import axios from "axios";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const TraineeSubCategoriesDialog = (props) => {
  const {
    loading,
    user,
    traineeCategory,
    traineeSubCategories,
    getTraineeSubCategories,
    saveTraineeSubCategory,
    showSubCategoryDialog,
    setShowSubCategoryDialog,
  } = props;

  const { hasPermissions } = useRequiredAuth();

  useEffect(() => {
    if (!!traineeCategory) getTraineeSubCategories(traineeCategory.id);
  }, [traineeCategory]);

  const [name, setName] = useState("");
  const [showAdd, setShowAdd] = useState(false);

  //PAGINATION
  const [paginatedItems, setPaginatedItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);

  const [itemOffset, setItemOffset] = useState(0);

  const itemsPerPage = 10;

  const paginate = (items) => {
    const endOffset = itemOffset + itemsPerPage;
    setPaginatedItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  };

  useEffect(() => {
    paginate(traineeSubCategories);
  }, [itemOffset, itemsPerPage, traineeSubCategories]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % traineeSubCategories.length || 0;

    setItemOffset(newOffset);
  };

  const getNo = (data, key, idToSearch) =>
    data.findIndex((item) => item[key] === idToSearch);

  const [formData, setFormData] = useState({
    id: null,
    name: "",
    traineeCategoryId: traineeCategory.id,
    isActive: true,
  });

  const onClose = () => {
    setFormData({
      id: null,
      name: "",
      traineeCategoryId: traineeCategory.id,
      isActive: true,
    });
    setShowAdd(false);
  };

  return (
    <Dialog
      onClose={() => setShowSubCategoryDialog(false)}
      open={showSubCategoryDialog}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className="text-primary">
        <Typography>
          <span className="text-primary text-uppercase">Sub Categories</span>
        </Typography>

        <IconButton
          aria-label="close"
          onClick={() => setShowSubCategoryDialog(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            minHeight: "5vh",
          }}
        >
          <Card className="border" variant="outlined">
            <div
              // className="mb-3"
              style={{
                // minHeight: "40vh",
                overflow: "auto",
              }}
            >
              <List
                dense
                component="div"
                subheader={
                  <ListSubheader
                    className="border-bottom py-2 bg-light text-uppercase text-primary  d-flex justify-content-between align-items-center"
                    component="div"
                  >
                    <Typography
                      className="text-primary font-weight-bold text-truncate"
                      style={{
                        maxWidth: "70%",
                      }}
                    >
                      {traineeCategory.name}
                    </Typography>

                    {/* {hasPermissions(["ADMIN"]) && ( */}
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => setShowAdd(true)}
                    >
                      <span className="material-icons">add</span> Add New
                    </Button>
                    {/* )} */}
                  </ListSubheader>
                }
              >
                {paginatedItems?.map((item, index) => (
                  <SubCategoryCardItem
                    index={getNo(traineeSubCategories, "id", item.id)}
                    key={item.id}
                    loading={loading}
                    user={user}
                    item={item}
                    traineeCategory={traineeCategory}
                    setFormData={setFormData}
                    setShowAdd={setShowAdd}
                    saveTraineeSubCategory={saveTraineeSubCategory}
                    onClose
                  />
                ))}
              </List>

              {!traineeSubCategories.length && (
                <div className="jumbotron jumbotron-fluid text-center">
                  <div className="container">
                    <p className="lead">
                      {loading ? "Fetching data..." : "No record found"}{" "}
                    </p>
                  </div>
                </div>
              )}
            </div>

            {traineeSubCategories.length > itemsPerPage && (
              <ReactPaginate
                breakLabel="..."
                nextLabel={
                  <>
                    <i className="fas fa-angle-double-right"></i>
                  </>
                }
                previousLabel={
                  <>
                    <i className="fas fa-angle-double-left"></i>
                  </>
                }
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                onPageChange={handlePageClick}
                pageCount={pageCount}
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
                activeLinkClassName="active"
              />
            )}

            {showAdd && (
              <AddOrEditSubCategory
                loading={loading}
                showAdd={showAdd}
                formData={formData}
                setFormData={setFormData}
                traineeCategory={traineeCategory}
                saveTraineeSubCategory={saveTraineeSubCategory}
                onClose={onClose}
              />
            )}
          </Card>
        </div>
      </DialogContent>
      {/* <DialogActions className="d-flex justify-content-center py-4"></DialogActions> */}
    </Dialog>
  );
};

const mapStateToProps = ({ user, loading, traineeSubCategories }) => {
  return {
    user,
    loading,
    traineeSubCategories,
  };
};

export default connect(mapStateToProps, {
  getTraineeSubCategories,
  saveTraineeSubCategory,
})(TraineeSubCategoriesDialog);

const SubCategoryCardItem = (props) => {
  const {
    loading,
    user,
    item,
    index,
    setFormData,
    setShowAdd,
    saveTraineeSubCategory,
    traineeCategory,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showConfirmDisable, setShowConfirmDisable] = useState(false);
  const [showTopicsDialog, setShowTopicsDialog] = useState(false);

  return (
    <>
      <ListItem
        style={{
          backgroundColor: !item.isActive ? "#ff00000f" : "#fff",
        }}
        // divider
        key={item.id}
        secondaryAction={
          <span>
            {!item.isActive && (
              <span
                style={{ fontSize: "12px" }}
                className={`material-icons text-danger mr-1`}
              >
                lock
              </span>
            )}

            <IconButton size="small" onClick={handleOpenMenu}>
              <Badge color="info">
                <span className="material-icons">more_vert</span>
              </Badge>
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleCloseMenu}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 2,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 15,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <span>
                <MenuItem
                  disabled={loading}
                  onClick={() => {
                    handleCloseMenu();

                    setFormData(item);
                    setShowAdd(true);
                  }}
                  className={`text-primary`}
                >
                  <span className="material-icons mr-2"> edit</span>
                  Edit
                </MenuItem>
              </span>

              <span>
                <MenuItem
                  disabled={loading}
                  onClick={() => {
                    handleCloseMenu();
                    setShowConfirmDisable(true);
                  }}
                  className={`text-${
                    !item.isActive ? "success" : "danger"
                  } font-weight-light`}
                >
                  {item.isActive && (
                    <span className="material-icons mr-2">close</span>
                  )}
                  {!item.isActive && (
                    <span className="material-icons mr-2">check</span>
                  )}
                  {item.isActive ? "Disable" : "Enable"}
                </MenuItem>
              </span>
            </Menu>
          </span>
        }
      >
        <ListItemText
          primary={
            <strong className="text-dark font-weight-light">
              {index + 1}: {item.name}
            </strong>
          }
          // secondary={<span>{item.traineeCategory.name}</span>}
        />
      </ListItem>

      {showConfirmDisable && (
        <ConfirmationDialog
          confirmationDialog={showConfirmDisable}
          message={
            <>
              Are you sure to{" "}
              <strong
                className={`text-${item.isActive ? "danger" : "success"}`}
              >
                {item.isActive ? "disable" : "enable"}
              </strong>{" "}
              this organization type?
            </>
          }
          setConfirmationDialog={setShowConfirmDisable}
          noPreFormat={true}
          onYes={() => {
            saveTraineeSubCategory(
              {
                id: item.id,
                name: item.name,
                traineeCategoryId: traineeCategory.id,
                isActive: !item.isActive,
              },
              () => setShowConfirmDisable(false)
            );
          }}
        />
      )}
    </>
  );
};

const AddOrEditSubCategory = (props) => {
  const {
    loading,
    showAdd,
    formData,
    setFormData,
    saveTraineeSubCategory,
    traineeCategory,
    onClose,
  } = props;

  const onSave = () => {
    saveTraineeSubCategory(
      {
        id: formData.id,
        name: formData.name,
        traineeCategoryId: traineeCategory.id,
        isActive: formData.isActive,
      },
      () => onClose()
    );
  };

  return (
    <Dialog onClose={onClose} open={showAdd} fullWidth maxWidth="xs">
      <DialogTitle className="text-primary">
        <Typography variant="p" noWrap component="div">
          <span className="text-primary">
            {formData.id ? "Edit " : "Add new "} sub category
          </span>
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            minHeight: "5vh",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            name="name"
            label={`Name`}
            placeholder={`Name`}
            variant="outlined"
            className="mt-3"
            value={formData.name || ""}
            onChange={(e) => {
              setFormData({
                ...formData,
                name: e.target.value || "",
              });
            }}
          />
        </div>
      </DialogContent>
      <DialogActions className="d-flex justify-content-center py-4">
        <Button
          variant="contained"
          color="primary"
          onClick={onSave}
          type="button"
          className="px-5"
          disabled={loading || !formData.name}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
